import React, { FC, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { useRecoilState } from "recoil";

import { APPLY_COUPON } from "graphql/service";
import {
  couponState,
  couponSuccessState,
} from "states/CheckOutStates/atoms";

import FormInputField from "components/FormInputField";
import StyledButton from "components/Button";
import { colors } from "constants/colors";
import { CouponContainer } from "./style";

const CouponInputBlock: FC = () => {
  const [coupon, setCoupon] = useRecoilState(couponState);
  const [couponSuccess, setCouponSuccess] = useRecoilState(couponSuccessState);

  const [couponInput, setCouponInput] = useState(coupon?.couponCode || "");
  const [couponError, setCouponError] = useState(false);

  const [applyCouponQuery] = useLazyQuery(APPLY_COUPON, {
    onCompleted: (data) => {
      const res = data?.couponByCode;

      if (res?.isActive) {
        setCoupon(res);
        setCouponSuccess(true);
        setCouponError(false);
        localStorage.setItem("coupon", JSON.stringify(res));
      } else {
        setCouponError(true);
        setCouponSuccess(false);
      }
    },

    onError: () => {
      setCouponError(true);
      setCouponSuccess(false);
    },
  });

  const handleApply = () => {
    if (!couponInput.trim()) return;

    applyCouponQuery({
      variables: {
        couponCode: couponInput.trim().toUpperCase(),
      },
    });
  };

  return (
    <CouponContainer>
      <FormInputField
        className="couponInput"
        placeholder="Coupon"
        placeholderColor={colors.noBookingText}
        placeholderFontSize="16px"
        inputFontSize="16px"
        borderColor={colors.signInBorderColor}
        inputHeight="50px"
        value={couponInput}
        error={couponError}
        errorMessage="Coupon code is invalid"
        success={couponSuccess}
        successMessage="Success! Coupon code applied."
        onChange={(e) => {
          setCouponInput(e.target.value);
          if (couponError) setCouponError(false);
          if (couponSuccess) setCouponSuccess(false);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleApply();
        }}
      />

      <StyledButton
        className="applyCouponButton"
        width="88px"
        height="50px"
        onClick={handleApply}
      >
        Apply
      </StyledButton>
    </CouponContainer>
  );
};

export default CouponInputBlock;